import { Pipe, PipeTransform } from '@angular/core';

/**
 * The rows from `start` to `end` of a table with windowing (appVirtualRows).
 * Pure: the sources replace their rows array on every change.
 */
@Pipe({ name: 'rowWindow', standalone: false })
export class RowWindowPipe implements PipeTransform {
  transform<T>(
    rows: readonly T[] | null | undefined,
    start: number,
    end: number
  ): T[] {
    return (rows ?? []).slice(start, end);
  }
}

/**
 * The query parameters of a company link from a table row: the context and
 * the index of the row in the whole list, for previous/next and the way back.
 */
@Pipe({ name: 'rowParams', standalone: false })
export class RowParamsPipe implements PipeTransform {
  transform(
    index: number,
    contextParams: Record<string, string>
  ): Record<string, string> {
    return { ...contextParams, row: String(index) };
  }
}
